// extracted by mini-css-extract-plugin
export default {"root":"RecoverPasswordToken__root--g2-HJF","center":"RecoverPasswordToken__center--JUSUnP","loginLink":"RecoverPasswordToken__loginLink--JLj+pN"};